<template>
  <section class="bg-white ">
    <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
      <div class="text-center text-gray-900">
        <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 lg:text-5xl " v-html="title"></h2>

      </div>
      <div class="grid gap-6 mt-12 lg:mt-14 lg:gap-12 md:grid-cols-3">
        <div class="flex mb-2 md:flex-col md:mb-0">

          <nuxt-img
              class="mr-4 w-auto h-36 md:w-full md:h-auto rounded-lg"
              width="379"
              height="379"
              loading="lazy"
              format="webp"
              sizes="sm:144px  md:379vw lg:379vw xl:379px"
              :alt="image1Alt"
              :src="image1"
          ></nuxt-img>


          <div>
            <h3 class="text-xl font-bold md:mt-4 mb-2.5 text-gray-900 " v-html="title1"></h3>
            <p class="text-gray-500 text-lg " v-html="description1">
            </p>
          </div>
        </div>
        <div class="flex mb-2 md:flex-col md:mb-0">


          <nuxt-img
              class="mr-4 w-auto h-36 md:w-full md:h-auto rounded-lg"
              width="379"
              height="379"
              loading="lazy"
              format="webp"
              sizes="sm:144px  md:379vw lg:379vw xl:379px"
              :alt="image2Alt"
              :src="image2"
          ></nuxt-img>


          <div>
            <h3 class="text-xl font-bold md:mt-4 mb-2.5 text-gray-900 " v-html="title2"></h3>
            <p class="text-gray-500 text-lg " v-html="description2">
            </p>
          </div>
        </div>
        <div class="flex md:flex-col">

          <nuxt-img
              class="mr-4 w-auto h-36 md:w-full md:h-auto rounded-lg"
              width="379"
              height="379"
              loading="lazy"
              format="webp"
              sizes="sm:144px  md:379vw lg:379vw xl:379px"
              :alt="image3Alt"
              :src="image3"
          ></nuxt-img>


          <div>
            <h3 class="text-xl font-bold md:mt-4 mb-2.5 text-gray-900 " v-html="title3"></h3>
            <p class="text-gray-500 text-lg " v-html="description3">
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>

defineProps({
  title: {
    type: String,
    default: 'How it works',
  },
  image1: {
    type: String,
    default: 'assets/images/sips-work-1.jpg',
  },
  image1Alt: {
    type: String,
    default: 'image Discover what lies within',
  },
  title1: {
    type: String,
    default: 'Discover what lies within.',
  },
  description1: {
    type: String,
    default: 'Every season, we curate an enticing fusion of our seasonal flavors, and all you need to do is let us know your preference—whole beans or ground.',
  },
  image2: {
    type: String,
    default: 'assets/images/sips-work-2.jpg',
  },
  image2Alt: {
    type: String,
    default: 'image Included in every box',
  },
  title2: {
    type: String,
    default: 'Included in every box',
  },
  description2: {
    type: String,
    default: 'Six delectable seasonal flavors await your taste buds, and a delightful surprise gift is tucked within.',
  },
  image3: {
    type: String,
    default: 'assets/images/sips-work-3.png',
  },
  image3Alt: {
    type: String,
    default: 'You\'ll relish',
  },
  title3: {
    type: String,
    default: 'You\'ll relish',
  },
  description3: {
    type: String,
    default: 'Each box arrives in pristine freshness, ensuring you can savor the seasonal flavors at their absolute peak of deliciousness!',
  },

})

defineBuilderComponent({
    friendlyName: "HowItWorks",
    canHaveChildren: true,
    inputs: [
        {
            name: "title",
            type: "richText",
            defaultValue: "How it works"
        },
        {
            name: "image1",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "assets/images/sips-work-1.jpg"
        },
        {
            name: "image1Alt",
            type: "text",
            defaultValue: "image Discover what lies within"
        },
        {
            name: "title1",
            type: "richText",
            defaultValue: "Discover what lies within."
        },
        {
            name: "description1",
            type: "richText",
            defaultValue: "Every season, we curate an enticing fusion of our seasonal flavors, and all you need to do is let us know your preference—whole beans or ground."
        },
        {
            name: "image2",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "assets/images/sips-work-2.jpg"
        },
        {
            name: "image2Alt",
            type: "text",
            defaultValue: "image Included in every box"
        },
        {
            name: "title2",
            type: "richText",
            defaultValue: "Included in every box"
        },
        {
            name: "description2",
            type: "richText",
            defaultValue: "Six delectable seasonal flavors await your taste buds, and a delightful surprise gift is tucked within."
        },
        {
            name: "image3",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "assets/images/sips-work-3.png"
        },
        {
            name: "image3Alt",
            type: "text",
            defaultValue: "You'll relish"
        },
        {
            name: "title3",
            type: "richText",
            defaultValue: "You'll relish"
        },
        {
            name: "description3",
            type: "richText",
            defaultValue: "Each box arrives in pristine freshness, ensuring you can savor the seasonal flavors at their absolute peak of deliciousness!"
        }
    ]
});
</script>